import React from 'react';

const OurPassion = () => {
    return (
        <section>
            <div className="align-center stg-bottom-gap-l">
                <h2 data-split-appear="fade-up" data-unload="fade-up">Our Core Values.</h2>
                <p className="infocolors-large-text" data-appear="fade-up" data-delay="100" data-unload="fade-up">Our work is built on a foundation of strong values that guide every interaction and creation:</p>
            </div>

            <div className="infocolors-grid-2cols" data-stagger-appear="zoom-in" data-delay="150" data-unload="fade-up">
                <div className="infocolors-icon-box infocolors-block">
                    <h4>Creativity<span className="infocolors-accent">.</span></h4>
                    <p className="infocolors-large-text">We celebrate and champion unique ideas and fresh perspectives in everything we do.</p>
                    <div className="infocolors-box-icon">
                        <i className="infocolors-icon infocolors-icon-creativity"></i>
                    </div>
                </div>
                <div className="infocolors-icon-box infocolors-block">
                    <h4>Collaboration<span className="infocolors-accent">.</span></h4>
                    <p className="infocolors-large-text">We believe in the power of synergy, fostering strong partnerships with talented individuals and organizations.</p>
                    <div className="infocolors-box-icon">
                        <i className="infocolors-icon infocolors-icon-collab"></i>
                    </div>
                </div>
                <div className="infocolors-icon-box infocolors-block">
                    <h4>Excellence<span className="infocolors-accent">.</span></h4>
                    <p className="infocolors-large-text">We are committed to delivering high-quality content that consistently inspires, entertains, and informs.</p>
                    <div className="infocolors-box-icon">
                        <i className="infocolors-icon infocolors-icon-impact"></i>
                    </div>
                </div>
                <div className="infocolors-icon-box infocolors-block">
                    <h4>Global Connection<span className="infocolors-accent">.</span></h4>
                    <p className="infocolors-large-text"> We strive to unite people through shared experiences, bridging cultures through art and information.</p>
                    <div className="infocolors-box-icon">
                        <i className="infocolors-icon infocolors-icon-innovation"></i>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurPassion;
